import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_workrelated_injuries_that_resulted_in_less_than_three_da'

export const dataPointDefinition = {
  retracedId: 'num_of_workrelated_injuries_that_resulted_in_less_than_three_da',
  name: 'Number of work-related injuries that resulted in less than three days of absence from work:',
  description:
    'Provide the number of work-related injuries that resulted in less than 3 days of absence from work.\r\r\n\r\r\nFor this question, do not include commuting injuries.\r\r\n',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fir-18',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17050,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
